import { IAppSetting } from '@addins/core/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ListNodeTags } from '@models/imported/SagaSchema/ListObjects/ListNodeTags';
import { FetchListService } from '@services/fetchlist/fetchlist.service';
import { AppSettingProviderService } from '@services/settings';
import { AddinView } from '@techwan/ionic-core';
import { Subscription } from 'rxjs';
import { ResponsibilityFilterService } from '../../../services/filters/responsibility-filter/responsibility-filter.service';

interface ResponsibilityCheckbox {
  label: string;
  value: string;
  checked: boolean;
}

@AddinView({
  name: 'CardListResponsibilityFilter'
})
@Component({
  selector: 'app-callcard-list-responsibility-filter',
  templateUrl: './callcard-list-responsibility-filter.component.html',
  styleUrls: ['./callcard-list-responsibility-filter.component.scss']
})
export class CallcardListResponsibilityFilterComponent implements OnInit, OnDestroy {
  private responsibilitiesToFilter: IAppSetting<string[]> = null;
  private onSaveSubscription: Subscription = null;

  responsibilityItems: ResponsibilityCheckbox[] = [];

  constructor(
    private responsibilityFilterService: ResponsibilityFilterService,
    private fetchListService: FetchListService,
    private appSettingProvider: AppSettingProviderService
  ) {}

  ngOnInit() {
    this.appSettingProvider.getSetting('ResponsibilitiesToFilter', [], true).subscribe(appSetting => {
      this.responsibilitiesToFilter = appSetting;
      this.createResponsibilityCheckboxes();
      this.onSaveSubscription = this.responsibilityFilterService.$onSave.subscribe(() => this.onFilterSave());
    });
  }

  private createResponsibilityCheckboxes() {
    const currentResponsibilitiesToFilter: string[] = this.responsibilitiesToFilter.current;
    this.responsibilityItems = this.fetchListService.getAllRows(ListNodeTags).map(nodeTag => {
      return {
        label: `${nodeTag.Name}`,
        checked: currentResponsibilitiesToFilter.includes(nodeTag.Value),
        value: nodeTag.Value
      };
    });
  }

  private onFilterSave() {
    const selectedResponsibilities: string[] = this.responsibilityItems.filter(item => item.checked).map(item => item.value);
    this.responsibilitiesToFilter.setValue(selectedResponsibilities);
  }

  ngOnDestroy() {
    this.onSaveSubscription?.unsubscribe();
  }
}
